import { createApolloClient } from 'config/apollo'
import { createCache } from 'apps/Diner/apollo/cache'

const client = createApolloClient({ cache: createCache() })

export default client
